import { dispatchCustomEvent } from "../../../../javascript/shared/helpers"

export default class extends Controller {
  static targets = ["form"]

  connect() {
    App.Helpers.addHandlers(this.element)
    App.Helpers.addAjaxSuccessHandler(this.formTarget, this.closeModalAndFireSuccessEvent.bind(this))
  }

  closeModalAndFireSuccessEvent(event, response) {
    App.SlideOut.closeAll()
    dispatchCustomEvent("assets--bulk-create-success", this.element, { newRows: response.assets })
  }

  cancel(event) {
    event.preventDefault()
    App.Modal.closeAll()
  }
}



// WEBPACK FOOTER //
// ./app/components/assets/assets/javascript/assets-bulk-asset-select-controller.js